/* eslint-disable */

import axios from 'axios';
const API_URL = 'http://api.sabinov.online';


export class APIService {
    constructor(){}
    
    async loadPosts(kategoria) {
        const url = `${API_URL}/posts`;
        const response = await axios.get(url, {params : {kategoria: kategoria}});
        return response.data;
    }

    getApiUrl() {
        return API_URL;
    }

    async savePost(postData) {
        const url = `${API_URL}/savepost`;                
        const params = new URLSearchParams();
        params.append('username', postData.username);
        params.append('userImage', postData.userImage);
        params.append('postImage', postData.postImage);
        params.append('likes', postData.likes);
        params.append('hasBeenLiked', postData.hasBeenLiked);
        params.append('caption', postData.caption);
        params.append('filter', postData.filter);
        params.append('category', postData.category);
        try {            
            await axios.post(url, params);                        
        }
        catch (error) {
            console.log(error);
        }        
    }

    async uploadFile(file) {
        let formData = new FormData();        
        formData.append('file', file);        
        let src = await axios.post(`${API_URL}/uploadimage`, formData, {headers: {'Content-Type':'multipart/form-data'}});           
        return src;         
    }

    increaseLike(id, status) {        
        if(status) {
           axios.post(`${API_URL}/inclikes`, {params : {'id' : id}});           
        } else {
           axios.post(`${API_URL}/declikes`, {params : {'id' : id}});           
        }
    }
}



// WEBPACK FOOTER //
// ./src/APIService.js